import { Dispatch, SetStateAction, useCallback } from 'react';

import { ToastMessage } from '@/types/appMessage';

export default function useDismissMessage(setMessages: Dispatch<SetStateAction<ToastMessage[]>>) {
  return useCallback(
    (messageId: string) => {
      setMessages((currentMessages) =>
        currentMessages.filter((message) => message.id !== messageId)
      );
    },
    [setMessages]
  );
}
